var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8651 11C19.5892 8.79508 18.5607 6.77083 16.9711 5.30439C15.3816 3.83794 13.3394 3.02932 11.225 3.02917C9.11067 3.02902 7.06837 3.83736 5.47862 5.30358C3.88887 6.7698 2.8601 8.79391 2.58398 10.9988",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2607 3.5L16.8453 0.999985",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 6.8335L20.9988 5.51977",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 6.8335L20.9988 5.51977",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56934 6.8335L1.00025 5.51977",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5459 1L8.13046 3.50002",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 2.75,
    stroke: "#5A8FC3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordOn);
export default __webpack_public_path__ + "static/media/password-on.958f541ec515674a41ff112bb2b29114.svg";
export { ForwardRef as ReactComponent };